import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class EventManagerService {
  public eventTypes: { [key: string]: any } = {
    'Placement Committee Reviewed': {
      color: 'var(--medium-blue-3)',
      label: 'Placement',
    },
    'Screening Committee': {
      color: 'var(--purple-3)',
      label: 'Screening',
    },
    'Capital Committee': {
      color: 'var(--lime-3)',
      label: 'Capital',
    },
    'Closed (Pre-LOI)': {
      color: 'var(--amber-4)',
      label: 'Closing (Pre-LOI)',
    },
    Closed: {
      color: 'var(--orange-3)',
      label: 'Closing',
    },
    'Capital Re-Approved': {
      color: 'var(--lime-5)',
      label: 'Capital Re-Approval',
    },
    'Full Closed': {
      color: 'var(--orange-5)',
      label: 'Full Closing',
    },
    'Disposition Committee': {
      color: 'var(--lime)',
      label: 'Disposition Committee',
    },
    'Disposition Closed': {
      color: 'var(--orange)',
      label: 'Disposition Closed',
    },
    'Fund Closing': {
      color: 'var(--yellow)',
      label: 'Fund Closing',
    },
    'Direct Funding Deadline': {
      color: 'var(--pink-5)',
      label: 'Direct Funding Deadline'
    },
    'Warehouse Funding Deadline': {
      color: 'var(--red-4)',
      label: 'Warehouse Funding Deadline'
    },
    'Closing Deadline': {
      color: 'var(--pink-2)',
      label: 'Closing Deadline'
    }
  };
  constructor() {
    let keys = this.typesList();
    for (let i = 0; i < keys.length; i++) {
      this.eventTypes[keys[i]].display = 'block';
      this.eventTypes[keys[i]].groupId = i.toString();
      this.eventTypes[keys[i]].checked = true;
      this.eventTypes[keys[i]].groupColor = this.eventTypes[keys[i]].color;
      if (keys[i] === 'Closed (Pre-LOI)' ||
          keys[i] === 'Closing Deadline'  ||
          keys[i] === 'Warehouse Funding Deadline' ||
          keys[i] === 'Direct Funding Deadline'
      ) {
        this.eventTypes[keys[i]].display = 'none';
        this.eventTypes[keys[i]].checked = false;
      }
    }
  }
  public showOnlyUserDeals: boolean = false;
  public typesList(): string[] {
    return Object.keys(this.eventTypes);
  }
  toggleEventDisplay(key: string): string {
    if (this.eventTypes[key].display === 'none') {
      this.eventTypes[key].display = 'block';
      this.eventTypes[key].checked = true;
    } else {
      this.eventTypes[key].display = 'none';
      this.eventTypes[key].checked = false;
    }
    return this.eventTypes[key].display;
  }

  toggleUserDeals(){
    this.showOnlyUserDeals = !this.showOnlyUserDeals;
    return this.showOnlyUserDeals
  }

  computeDisplay(groupName: string, isMine:boolean) : string {
    let typeEntry = this.eventTypes[groupName]
    let typeVisible = !!typeEntry && typeEntry.display !== 'none'
    if(!typeVisible){
      return 'none'
    }
    if(this.showOnlyUserDeals && !isMine){
      return 'none'
    }
    return 'block'
  }
  getColorClass(key: string): string {
    let color = this.eventTypes[key].color;
    return (
      'checkbox-' + color.substring(color.indexOf('-') + 2, color.indexOf(')'))
    );
  }
  generateEventData(index: string, date: string) {
    let start: string = '';
    switch (index) {
      case 'Placement Committee Reviewed':
        start = date + 'T' + '00:00:00';
        break;
      case 'Screening Committee':
        start = date + 'T' + '00:05:00';
        break;
      case 'Capital Committee':
        start = date + 'T' + '00:10:00';
        break;
      case 'Closed (Pre-LOI)':
        start = date + 'T' + '00:14:30';
        break;
      case 'Closed':
        start = date + 'T' + '00:15:00';
        break;
      case 'Capital Re-Approved':
        start = date + 'T' + '00:20:00';
        break;
      case 'Full Closed':
        start = date + 'T' + '00:25:00';
        break;
      case 'Disposition Committee':
        start = date + 'T' + '00:35:00';
        break;
      case 'Disposition Closed':
        start = date + 'T' + '00:40:00';
        break;
      case 'Fund Closing':
        start = date + 'T' + '00:40:00';
        break;
      case 'Warehouse Funding Deadline':
        start = date + 'T' + '00:45:00';
        break;
      case 'Direct Funding Deadline':
        start = date + 'T' + '00:45:00';
        break;
      case 'Closing Deadline':
        start = date + 'T' + '00:50:00';
        break;
    }

    return {
      start,
      ...this.eventTypes[index],
      groupName: index,
    };
  }

  isChecked(key: string): boolean {
    let isChecked = this.eventTypes[key].display !== 'none';
    return isChecked;
  }
}
